import React from 'react';
import styles from './Body.module.css';
import { Header, FilterHeader } from '../Header';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const Body = props => {
  const {
    goBack,
    stationView,
    toggleCheckbox,
    changeView,
    excludeTerminated,
    tableWithSensors,
    jobAllowsAssignment,
    assigned,
    sortByName,
    onChangeSortByName,
    searchEmployeeValue,
    onSearchEmployee,
  } = props;

  return (
    <div className={styles.container}>
      <Header
        goBack={goBack}
        toggleCheckbox={toggleCheckbox}
        changeView={changeView}
        stationView={stationView}
        excludeTerminated={excludeTerminated}
        tableWithSensors={tableWithSensors}
        jobAllowsAssignment={jobAllowsAssignment}
        assigned={assigned}
      />
      <div className={styles.bodyWrapper}>
        <div className={styles.leftSectionWrapper}>
          <FilterHeader
            sortByName={sortByName}
            onChangeSortByName={onChangeSortByName}
            stationView={stationView}
            searchEmployeeValue={searchEmployeeValue}
            onSearchEmployee={onSearchEmployee}
          />
          <LeftSection {...props} />
        </div>
        <RightSection {...props} />
      </div>
    </div>
  );
};

export default Body;
